import 'mathlive/dist/mathlive.min';
import * as React from 'react';
import Button from '@mui/material/Button';
import {
  quickKeyButtons,
  quickSymbolButtons,
  greekButtons,
  relationsButtons,
  logicsButtons,
  calculusButtons,
} from '../../../../../../constants';

export interface IModalButtons {
  open: boolean;
}

export interface IProps {
  toggleTabs: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addLatex: (text: any) => void;
}

class ModalButtons extends React.Component<IProps, IModalButtons> {
  constructor(props: IProps) {
    super(props);
    // INIT METHODS
    this.handleLatex = this.handleLatex.bind(this);
  }

  handleLatex(value: string): void {
    const { addLatex } = this.props;
    addLatex(value);
  }

  render(): JSX.Element {
    const { toggleTabs } = this.props;
    return (
      <div>
        {toggleTabs && toggleTabs === 'quick' && (
          <div className="equation-button-container">
            {quickKeyButtons &&
              quickKeyButtons.map((button, index) => {
                return (
                  <Button
                    key={index}
                    variant="outlined"
                    color="secondary"
                    style={{
                      marginTop: '10px',
                      marginLeft: '5px',
                      textTransform: 'none',
                    }}
                    onClick={() => this.handleLatex(button.value)}
                  >
                    {button.name}
                  </Button>
                );
              })}
            {quickSymbolButtons &&
              quickSymbolButtons.map((button, index) => {
                return (
                  <Button
                    key={index}
                    variant="outlined"
                    style={{
                      marginTop: '10px',
                      marginLeft: '5px',
                    }}
                    onClick={() => this.handleLatex(button.value)}
                  >
                    {button.name}
                  </Button>
                );
              })}
          </div>
        )}
        {toggleTabs && toggleTabs === 'greek' && (
          <div className="equation-button-container">
            {greekButtons &&
              greekButtons.map((button, index) => {
                return (
                  <Button
                    key={index}
                    variant="outlined"
                    style={{
                      marginTop: '10px',
                      marginLeft: '5px',
                      textTransform: 'none',
                    }}
                    onClick={() => this.handleLatex(button.value)}
                  >
                    {button.name}
                  </Button>
                );
              })}
          </div>
        )}
        {toggleTabs && toggleTabs === 'relations' && (
          <div className="equation-button-container">
            {relationsButtons &&
              relationsButtons.map((button, index) => {
                return (
                  <Button
                    key={index}
                    variant="outlined"
                    style={{
                      marginTop: '10px',
                      marginLeft: '5px',
                      textTransform: 'none',
                    }}
                    onClick={() => this.handleLatex(button.value)}
                  >
                    {button.name}
                  </Button>
                );
              })}
          </div>
        )}
        {toggleTabs && toggleTabs === 'logics' && (
          <div className="equation-button-container">
            {logicsButtons &&
              logicsButtons.map((button, index) => {
                return (
                  <Button
                    key={index}
                    variant="outlined"
                    style={{
                      marginTop: '10px',
                      marginLeft: '5px',
                      textTransform: 'none',
                    }}
                    onClick={() => this.handleLatex(button.value)}
                  >
                    {button.name}
                  </Button>
                );
              })}
          </div>
        )}
        {toggleTabs && toggleTabs === 'calculus' && (
          <div className="equation-button-container">
            {calculusButtons &&
              calculusButtons.map((button, index) => {
                return (
                  <Button
                    key={index}
                    variant="outlined"
                    style={{
                      marginTop: '10px',
                      marginLeft: '5px',
                      textTransform: 'none',
                    }}
                    onClick={() => this.handleLatex(button.value)}
                  >
                    {button.name}
                  </Button>
                );
              })}
          </div>
        )}
      </div>
    );
  }
}

export default ModalButtons;
